import Header from '../../components/layout/Header';
import Table from '@/components/confirmation/Table';
import ButtonGroup from '@/components/confirmation/ButtonGroup';
import Heading from '@/components/confirmation/Heading';
import * as React from 'react';
import useCartStore from '@/stores/cart.store';
import useGlobalStore from '@/stores/global.store';

export default function Confirmation() {
  const clearCart = useCartStore((state) => state.clearCart);
  const reset = useGlobalStore((state) => state.reset);

  React.useEffect(() => {
    clearCart();
    reset();
  }, []);

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        {/* <Header /> */}

        <main className="grow">
          <div className="lg:relative lg:flex">
            {/* Content */}
            <div className="px-4 sm:px-6 lg:px-8 py-8 lg:grow">
              <div className="lg:max-w-[640px] lg:mx-auto">
                <div className="mb-6 lg:mb-0 flex flex-col items-center">
                  <section className="py-8 antialiased dark:bg-gray-900 md:py-16">
                    <div className="mx-auto max-w-2xl px-4 2xl:px-0">
                      <Heading />
                      <Table />
                      <ButtonGroup />
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
